export const russianMessages: Record<string, string> = {
  "Language": "Язык",
  "English": "Английский",
  "Russian": "Русский",
  "Use English": "Переключить на английский",
  "Use Russian": "Переключить на русский",
  "CodexNow home": "Главная CodexNow",
  "Main navigation": "Основная навигация",
  "Open navigation": "Открыть навигацию",
  "Close navigation": "Закрыть навигацию",
  "Operator navigation": "Навигация оператора",
  "Dashboard navigation": "Навигация кабинета",
  "Notifications": "Уведомления",
  "Service benefits": "Преимущества сервиса",
  "USD payments": "Оплата в долларах США",
  "No subscription": "Без подписки",
  "OpenAI-compatible API": "Совместимо с OpenAI API",
  "AI API with USD billing": "API для ИИ с оплатой в долларах США",
  "AI models.": "ИИ-модели.",
  "Pay in dollars.": "Оплата в долларах.",
  "One key for Codex and OpenAI-compatible clients. Top up any amount and pay only for the tokens you use.":
    "Один API-ключ для Codex и OpenAI-совместимых клиентов. Пополняйте баланс на удобную сумму и платите только за использованные токены.",
  "Start using API": "Начать работу",
  "How to connect": "Как подключиться",
  "Request content is not stored": "Без хранения запросов",
  "Connection summary": "Параметры подключения",
  "Ready to connect": "Готово к подключению",
  "Featured model": "Основная модель",
  "Price from": "Стоимость от",
  "per 1M input tokens": "за 1 млн входных токенов",
  "Wallet currency": "Баланс",
  "US dollars": "Доллары США",
  "Billing unit": "Оплата",
  "Every request": "За каждый запрос",
  "API base URL": "Адрес API",
  "View available models": "Доступные модели",
  "Why CodexNow": "Преимущества CodexNow",
  "USD throughout": "Единый баланс в USD",
  "The balance and every charge are shown in USD.": "Баланс и стоимость каждого запроса отображаются в USD.",
  "Pay only for usage": "Только за использование",
  "No monthly plan or automatic subscription charge.": "Без абонентской платы и автоматических списаний.",
  "Control every key": "Контроль каждого ключа",
  "Models, expiration, and request limits are configured separately.":
    "Модели, срок действия и лимиты настраиваются отдельно.",
  "How it works": "Как начать",
  "Three steps to your first request": "Три шага до первого запроса",
  "No complex setup: create an account, get a key, and point your client to CodexNow.":
    "Без сложной настройки: зарегистрируйтесь, получите ключ и укажите адрес CodexNow в своём клиенте.",
  "Top up the balance": "Пополните баланс",
  "Choose an amount in dollars. One dollar paid becomes one dollar of credit.":
    "Выберите удобную сумму. Один оплаченный доллар становится одним долларом на балансе.",
  "Create an API key": "Создайте API-ключ",
  "Set model access and limits. The secret is shown once.":
    "Выберите доступные модели и лимиты. Секретный ключ показывается один раз.",
  "Connect Codex or your SDK": "Подключите Codex или SDK",
  "Replace the base URL and send the key as a Bearer token.":
    "Замените адрес API и передавайте ключ как Bearer-токен.",
  "Familiar API, local billing": "Знакомый API, оплата в USD",
  "Keep your existing client.": "Не меняйте привычный клиент.",
  "CodexNow uses the familiar OpenAI-compatible API. Change the address and key—your request format stays the same.":
    "CodexNow поддерживает привычный OpenAI-совместимый API. Меняются только адрес и ключ — формат запросов остаётся прежним.",
  "Ready for the first request?": "Готовы отправить первый запрос?",
  "Connect in a few minutes.": "Подключитесь за несколько минут.",
  "Create an account, top up the balance, and use your API key in Codex or another compatible client.":
    "Создайте аккаунт, пополните баланс и укажите API-ключ в Codex или другом совместимом клиенте.",
  "View pricing": "Посмотреть тарифы",
  "Close": "Закрыть",
  "Pagination": "Пагинация",
  "Overview": "Главная",
  "Wallet": "Кошелёк",
  "Payments": "Платежи",
  "API keys": "API-ключи",
  "Usage": "Запросы",
  "Sessions": "Сеансы",
  "Security": "Безопасность",
  "Settings": "Настройки",
  "Accounts": "Аккаунты",
  "Usage explorer": "Все запросы",
  "Statistics": "Статистика",
  "Models": "Модели",
  "Payment events": "События оплаты",
  "Audit log": "Аудит",
  "Jobs": "Фоновые задачи",
  "Mail": "Письма",
  "System": "Система",
  "Operator console": "Панель оператора",
  "Customer workspace": "Личный кабинет",
  "Customer view": "Личный кабинет",
  "Light theme": "Светлая тема",
  "Dark theme": "Тёмная тема",
  "Use light theme": "Включить светлую тему",
  "Use dark theme": "Включить тёмную тему",
  "Sign out": "Выйти",
  "Pricing": "Тарифы",
  "Docs": "Документация",
  "Dashboard": "Кабинет",
  "Sign in": "Войти",
  "Get started": "Регистрация",
  "API docs": "API-документация",
  "Support": "Поддержка",
  "Provider-neutral, prepaid access to operator-configured AI models.":
    "ИИ-модели через единый API с оплатой в USD.",
  "Something went wrong": "Что-то пошло не так",
  "Try again": "Повторить",
  "Loading…": "Загрузка…",
  "Previous": "Назад",
  "Next": "Далее",
  "Page {page} of {total}": "Страница {page} из {total}",
  "No usage in this range": "За этот период нет данных",
  "Try a wider date range or clear the filters.": "Расширьте диапазон дат или сбросьте фильтры.",
  "Usage over time": "Использование по времени",
  "Save your API key": "Сохраните API-ключ",
  "This is the only time the raw key will be shown. CodexNow does not store it and cannot reveal it again.":
    "Ключ показывается полностью только сейчас. CodexNow не хранит его и не сможет показать повторно.",
  "Copied": "Скопировано",
  "Copy": "Копировать",
  "I have stored this key securely and understand it cannot be recovered.":
    "Я надёжно сохранил ключ и понимаю, что восстановить его невозможно.",
  "I saved the key": "Я сохранил ключ",
  "{count} result | {count} results": "{count} результат | {count} результата | {count} результатов",
  "Unknown": "Неизвестно",
  "Unknown browser": "Неизвестный браузер",
  "Your local session was cleared. The server could not confirm logout.":
    "Локальная сессия завершена, но сервер не смог подтвердить выход.",
  "USD amount must be a valid number.": "Сумма в USD должна быть корректным числом.",
  "USD amount must be finite.": "Сумма в USD должна быть конечным числом.",
  "An unexpected error occurred.": "Произошла непредвиденная ошибка.",
  "The management API could not be reached.": "Не удалось подключиться к API управления.",
  "Network request failed": "Ошибка сетевого запроса",
  "Request failed": "Ошибка запроса",
  ", copy it from the one-time display, and send it as a Bearer token.":
    ", скопируйте его из одноразового окна и отправляйте как Bearer-токен.",
  "? Existing clients using it will immediately lose access.": "? Использующие его клиенты сразу потеряют доступ.",
  ". LiteLLM applies the same virtual-key authentication, model access, budgets, and limits used by HTTP requests. This is the Responses transport for text-and-tool loops, not the Realtime audio API.":
    ". LiteLLM применяет ту же аутентификацию виртуальным ключом, доступ к моделям, бюджеты и лимиты, что и для HTTP-запросов. Это транспорт Responses для циклов с текстом и инструментами, а не аудио-API Realtime.",
  ". Only the routes documented here are public.": ". Публичны только описанные здесь маршруты.",
  ". Streaming is implicit over WebSocket, so clients do not send":
    ". При WebSocket потоковая передача включена автоматически, поэтому клиенты не отправляют",
  ". The browser redirect does not settle the payment; verified provider confirmation does.":
    ". Перенаправление браузера не подтверждает платёж — это делает проверенное подтверждение провайдера.",
  ". The last known balance is shown; it has not been replaced with zero.":
    ". Показан последний известный баланс, он не заменён нулём.",
  ". Values show the last known state from": ". Показано последнее известное состояние на",
  "· Expires no later than": "· Истекает не позднее",
  "· Last seen": "· Последняя активность",
  "· Last used": "· Последнее использование",
  "(none means all active models)": "(если ничего не выбрано — все активные модели)",
  "(none selected means all account models)": "(если ничего не выбрано — все модели аккаунта)",
  "12–128 characters. Use a unique password.": "От 12 до 128 символов. Используйте уникальный пароль.",
  "200 · streaming response": "200 · потоковый ответ",
  "Account": "Аккаунт",
  "Account detail": "Данные аккаунта",
  "Account details": "Сведения об аккаунте",
  "Account ID": "ID аккаунта",
  "Account invoice history.": "История счетов аккаунта.",
  "Account limit": "Лимит аккаунта",
  "Account limits and models": "Лимиты и модели аккаунта",
  "Account profile": "Профиль аккаунта",
  "Account ranking": "Рейтинг аккаунтов",
  "Account settings": "Настройки аккаунта",
  "Account status": "Статус аккаунта",
  "Account total": "Всего по аккаунту",
  "Account total and every current or revoked key for the selected range.":
    "Общий итог аккаунта и каждый действующий или отозванный ключ за выбранный период.",
  "Account usage includes metadata only; request content does not exist in CodexNow.":
    "Использование аккаунта содержит только метаданные; содержимое запросов в CodexNow не хранится.",
  "Account-wide policy": "Общие правила аккаунта",
  "Action": "Действие",
  "Active": "Активна",
  "active keys. Limits on a key must be equal to or stricter than account limits.":
    "активных ключей. Ограничения ключа должны быть не выше ограничений аккаунта.",
  "Activity": "Активность",
  "Actor": "Инициатор",
  "Actor user ID": "ID пользователя-инициатора",
  "Add an internal support note": "Добавить внутреннюю заметку поддержки",
  "Add credit": "Пополнить баланс",
  "Add note": "Добавить заметку",
  "Add the account to your authenticator using this provisional secret.":
    "Добавьте аккаунт в приложение-аутентификатор с помощью этого временного секрета.",
  "Add this provisional secret to your authenticator:": "Добавьте этот временный секрет в приложение-аутентификатор:",
  "Adjust credit": "Изменить баланс",
  "Adjustment": "Корректировка",
  "ADMIN": "Администратор",
  "ADMIN_ADJUSTMENT": "Корректировка администратором",
  "Administrative access requires a time-based one-time password.":
    "Для административного доступа требуется одноразовый пароль с ограниченным сроком действия.",
  "Administrative controls": "Административное управление",
  "Administrative MFA can only be disabled after a super admin demotes the account.":
    "Административную MFA можно отключить только после того, как главный администратор понизит роль аккаунта.",
  "After": "После",
  "All API keys": "Все API-ключи",
  "Agent clients can keep a persistent Responses API connection open at":
    "Клиенты-агенты могут поддерживать постоянное соединение Responses API по адресу",
  "Aggregate customer billing, upstream cost, usage, model, and account rankings.":
    "Сводные данные по оплате клиентов, внешним затратам, использованию, моделям и рейтингу аккаунтов.",
  "Alias": "Название",
  "All keys": "Все ключи",
  "All models": "Все модели",
  "All statuses": "Все статусы",
  "Allowed models": "Разрешённые модели",
  "Allowed range:": "Допустимый диапазон:",
  "Already have an account?": "Уже есть аккаунт?",
  "Amount": "Сумма",
  "Analytics": "Аналитика",
  "Any role": "Любая роль",
  "Any status": "Любой статус",
  "Any verification": "Любое подтверждение",
  "API guide": "Руководство по API",
  "API key": "API-ключ",
  "API request example": "Пример API-запроса",
  "Append-only operator and system actions with role-based field redaction.":
    "Неизменяемый журнал действий операторов и системы с сокрытием полей в зависимости от роли.",
  "Apply": "Применить",
  "Apply adjustment": "Применить корректировку",
  "Apply filters": "Применить фильтры",
  "Apply status": "Изменить статус",
  "ASC": "По возрастанию",
  "Attempts": "Попытки",
  "Attention:": "Внимание:",
  "Audit record": "Запись аудита",
  "Authentication code": "Код аутентификации",
  "Authoritative prepaid credits, billable spend, and immutable ledger history.":
    "Актуальный предоплаченный баланс, оплачиваемые расходы и неизменяемая история операций.",
  "Available": "Доступно",
  "Available account credit is exhausted.": "Доступный баланс аккаунта исчерпан.",
  "Back to sign in": "Вернуться ко входу",
  "Background job detail": "Сведения о фоновой задаче",
  "Background jobs": "Фоновые задачи",
  "Balance enforcement data is": "Данные контроля баланса:",
  "Base cost": "Базовая стоимость",
  "Before": "До",
  "Begins a controlled anonymization workflow and revokes virtual keys.":
    "Запускает управляемую анонимизацию и отзывает виртуальные ключи.",
  "Billable cost": "Стоимость к оплате",
  "Billed": "Начислено",
  "Bucket": "Период",
  "Budget": "Бюджет",
  "Budget sync": "Синхронизация бюджета",
  "Buy only the credit you need.": "Пополняйте баланс на нужную сумму.",
  "Cached input": "Кэшированный ввод",
  "Cached input / 1M": "Кэшированный ввод / 1 млн",
  "Cached input USD / 1M": "Кэшированный ввод, USD / 1 млн",
  "Cancel": "Отмена",
  "Cancel invoice": "Отменить счёт",
  "Capabilities": "Возможности",
  "Category": "Категория",
  "Challenge expires": "Срок действия запроса истекает",
  "Change account role": "Изменить роль аккаунта",
  "Change account status": "Изменить статус аккаунта",
  "Change elevated access": "Изменить расширенный доступ",
  "Change role": "Изменить роль",
  "Changing it revokes every website session.": "После изменения все веб-сессии будут завершены.",
  "CHARGEBACK": "Возвратный платёж",
  "Chat completions": "Chat Completions",
  "Chat Completions": "Chat Completions",
  "Check your inbox": "Проверьте почту",
  "Check your inbox. The link expires in 30 minutes.": "Проверьте входящие. Ссылка действует 30 минут.",
  "Checked": "Проверено",
  "Choose a new password": "Выберите новый пароль",
  "Clear cost control": "Расходы под контролем",
  "Codex and Responses WebSocket": "WebSocket для Codex и Responses",
  "Codex sends": "Codex отправляет события",
  "Codex WebSocket": "WebSocket Codex",
  "CodexNow": "CodexNow",
  "CodexNow inference API": "API инференса CodexNow",
  "CodexNow retains request metadata—including model, tokens, cost, latency, and safe error code—but does not retain prompts, outputs, tool inputs, or attachments. Configured upstream providers process request content under their terms.":
    "CodexNow хранит метаданные запросов — модель, токены, стоимость, задержку и безопасный код ошибки, — но не промпты, ответы, входные данные инструментов и вложения. Настроенные внешние провайдеры обрабатывают содержимое запросов на своих условиях.",
  "CodexNow stores usage metadata—not prompts, tool inputs, attachments, or generated output.":
    "Мы сохраняем только технические данные об использовании, но не тексты запросов, ответы и вложения.",
  "Completed": "Завершено",
  "Completing this reset signs out every existing website session.":
    "После сброса пароля все активные веб-сессии будут завершены.",
  "Concurrent": "Параллельные запросы",
  "Concurrent requests": "Параллельные запросы",
  "Configuration": "Конфигурация",
  "Confirm": "Подтвердить",
  "Confirm new password": "Подтвердите новый пароль",
  "Confirm password": "Подтвердите пароль",
  "Confirming your link…": "Подтверждаем ссылку…",
  "Connect to the configured inference base URL and use your virtual key as a Bearer token.":
    "Укажите адрес CodexNow вместо адреса OpenAI и передавайте API-ключ как Bearer-токен.",
  "Consumed": "Использовано",
  "Content fields do not exist in this contract.": "Поля с содержимым отсутствуют в этом контракте.",
  "Content stays out": "Без хранения запросов",
  "Context window": "Контекстное окно",
  "Context window tokens": "Токенов в контекстном окне",
  "Continue": "Продолжить",
  "Continue to sign in": "Перейти ко входу",
  "Control-plane mirror state.": "Состояние копии управляющего контура.",
  "CORRECTION": "Исправление",
  "Cost": "Стоимость",
  "Create a key": "Создать ключ",
  "Create a key to call the configured inference API.": "Создайте ключ для обращения к настроенному API инференса.",
  "Create a top-up from your wallet.": "Создайте пополнение в кошельке.",
  "Create a virtual key in": "Создайте виртуальный ключ в разделе",
  "Create an account": "Создать аккаунт",
  "Create API key": "Создать API-ключ",
  "Create scoped virtual keys. Raw secrets are displayed once and never stored by CodexNow.":
    "Создавайте виртуальные ключи с ограничениями. Секрет показывается один раз и не хранится в CodexNow.",
  "Create your account": "Создайте аккаунт",
  "Create your first key": "Создать первый ключ",
  "Created": "Создано",
  "CREDIT": "Зачисление",
  "Credit adjustment": "Корректировка баланса",
  "Credits are denominated in USD. Model usage rates are shown on the models page.":
    "Средства учитываются в USD. Тарифы моделей указаны на странице моделей.",
  "Cross-account request metadata without prompt or output content.":
    "Метаданные запросов всех аккаунтов без промптов и ответов.",
  "CRYPTO_PAY": "Crypto Pay",
  "Current access credentials": "Текущие данные доступа",
  "Current password": "Текущий пароль",
  "Customer": "Клиент",
  "CUSTOMER": "Клиент",
  "Daily": "По дням",
  "Data handling": "Обработка данных",
  "Date": "Дата",
  "DEBIT": "Списание",
  "Delete account": "Удалить аккаунт",
  "Delivery": "Доставка",
  "DESC": "По убыванию",
  "Description": "Описание",
  "Details": "Подробнее",
  "Developer documentation": "Документация разработчика",
  "Direction": "Направление",
  "Disable MFA": "Отключить MFA",
  "Disable TOTP": "Отключить TOTP",
  "Disable two-factor authentication": "Отключить двухфакторную аутентификацию",
  "Display name": "Отображаемое имя",
  "Edit": "Изменить",
  "Edit account": "Изменить аккаунт",
  "Edit public model": "Изменить публичную модель",
  "Email": "Электронная почта",
  "Email address": "Адрес электронной почты",
  "Email verified": "Почта подтверждена",
  "Enable authenticator app": "Подключить приложение-аутентификатор",
  "Enable TOTP": "Включить TOTP",
  "Enter a TOTP code or one unused recovery code.": "Введите код TOTP или неиспользованный код восстановления.",
  "Enter how many USD to add. The full paid amount becomes wallet credit and does not expire.":
    "Укажите сумму пополнения в USD. Вся оплаченная сумма зачислится в кошелёк и не сгорит.",
  "Enter the six-digit code it generates.": "Введите сгенерированный шестизначный код.",
  "Entries are immutable; corrections appear as new rows.": "Операции неизменяемы; исправления добавляются отдельными строками.",
  "entry.": "операцию.",
  "Error code": "Код ошибки",
  "Errors": "Ошибки",
  "Europe/Minsk": "Europe/Minsk",
  "Event key": "Ключ события",
  "Event type": "Тип события",
  "events and can continue tool-heavy turns with": "и может продолжать насыщенные инструментами запросы с помощью",
  "Exact recipient": "Точный получатель",
  "Existing customers can continue to sign in. Contact support if you need help.":
    "Существующие клиенты могут продолжать входить. Если нужна помощь, обратитесь в поддержку.",
  "Expiration (optional)": "Срок действия (необязательно)",
  "Expires": "Истекает",
  "Explore usage →": "Все запросы →",
  "FAILED": "Ошибка",
  "failed jobs,": "задач с ошибкой,",
  "Filter": "Фильтр",
  "Finish": "Завершить",
  "Forgot password?": "Забыли пароль?",
  "From": "С",
  "Full statistics →": "Полная статистика →",
  "Fund a USD wallet, choose from operator-configured models, and keep spend visible down to every request—without subscriptions.":
    "Пополняйте баланс в USD, выбирайте модель и смотрите стоимость каждого запроса. Без подписки и скрытых списаний.",
  "Gateway, routing, or upstream dependency failure. Retry only when safe.":
    "Ошибка шлюза, маршрутизации или внешней зависимости. Повторяйте запрос только когда это безопасно.",
  "Generated": "Сформировано",
  "GET /v1/models": "GET /v1/models",
  "Gross profit": "Валовая прибыль",
  "High-impact action.": "Действие с серьёзными последствиями.",
  "Hourly": "По часам",
  "I accept the terms and privacy policy.": "Я принимаю условия использования и политику конфиденциальности.",
  "I confirm this immutable": "Я подтверждаю эту неизменяемую",
  "I delivered the link": "Я передал ссылку",
  "I have securely stored these codes.": "Я надёжно сохранил эти коды.",
  "I stored these recovery codes.": "Я сохранил коды восстановления.",
  "I understand this begins account deletion.": "Я понимаю, что это запускает удаление аккаунта.",
  "I understand this creates customer credit.": "Я понимаю, что это создаст средства на балансе клиента.",
  "ID": "ID",
  "Identity and current lifecycle state.": "Идентификационные данные и текущее состояние аккаунта.",
  "If the account is eligible, a new link has been sent.": "Если аккаунт подходит, новая ссылка отправлена.",
  "Immutable credit and debit entries.": "Неизменяемые операции зачисления и списания.",
  "in these events.": "в этих событиях.",
  "Independent service. Not affiliated with or endorsed by OpenAI.":
    "Независимый сервис, не связанный с OpenAI.",
  "Inference credentials": "Данные доступа к API",
  "Input / 1M": "Вход / 1 млн токенов",
  "Input USD / 1M": "Ввод, USD / 1 млн",
  "Input tokens": "Входные токены",
  "Inspect": "Просмотреть",
  "Inspect background jobs": "Просмотреть фоновые задачи",
  "Inspect outbox work, attempts, leases, failures, and idempotent retries.":
    "Просмотр очереди, попыток, блокировок, ошибок и идемпотентных повторов.",
  "Internal notes": "Внутренние заметки",
  "Interval": "Интервал",
  "Invalid": "Недействительна",
  "Invoice": "Счёт",
  "Invoice ready": "Счёт готов",
  "Invoices and settlement state from the configured payment provider.":
    "Счета и состояние расчётов от настроенного платёжного провайдера.",
  "Issue password reset": "Создать сброс пароля",
  "Issue reset": "Создать сброс",
  "Keep key": "Оставить ключ",
  "Key": "Ключ",
  "Key alias": "Название ключа",
  "Key ID": "ID ключа",
  "Key/account rate or concurrency limit.": "Превышен лимит частоты или параллельных запросов ключа либо аккаунта.",
  "Keys": "Ключи",
  "Keys with boundaries": "Лимиты для каждого ключа",
  "Last error": "Последняя ошибка",
  "Last login": "Последний вход",
  "Last reconciled": "Последняя сверка",
  "Last request": "Последний запрос",
  "Last synchronized": "Последняя синхронизация",
  "Last used": "Последнее использование",
  "Latency": "Задержка",
  "Limits & models": "Лимиты и модели",
  "LiteLLM name": "Имя LiteLLM",
  "LiteLLM user": "Пользователь LiteLLM",
  "Lifetime account total and every current or revoked key.":
    "Общий итог аккаунта за всё время и каждый действующий или отозванный ключ.",
  "Mail outbox": "Исходящая почта",
  "Manage": "Управление",
  "Manage your password and multi-factor authentication.": "Управляйте паролем и многофакторной аутентификацией.",
  "Mandatory revocation reason": "Обязательная причина отзыва",
  "Manual payment settlement": "Ручное подтверждение платежа",
  "Manual settlement": "Ручное подтверждение",
  "Margin": "Маржа",
  "Maximum top-up": "Максимальное пополнение",
  "Metadata retained for usage and diagnostics.": "Метаданные, сохранённые для учёта и диагностики.",
  "MFA": "MFA",
  "MFA enrollment must be completed before operator routes are available.":
    "Перед доступом к разделам оператора необходимо настроить MFA.",
  "Minimum top-up": "Минимальное пополнение",
  "Missing, invalid, or revoked virtual key.": "Виртуальный ключ отсутствует, недействителен или отозван.",
  "Model": "Модель",
  "Model catalog": "Доступные модели",
  "Model discovery": "Поиск моделей",
  "Models that fit the work.": "Модели под ваши задачи.",
  "Name": "Имя",
  "Negative balance": "Отрицательный баланс",
  "New account creation is not currently available.": "Создание новых аккаунтов сейчас недоступно.",
  "New password": "Новый пароль",
  "New status": "Новый статус",
  "New to CodexNow?": "Впервые в CodexNow?",
  "New top-up": "Новое пополнение",
  "Next attempt": "Следующая попытка",
  "No accounts match these filters": "Нет аккаунтов, соответствующих фильтрам",
  "No active sessions": "Нет активных сессий",
  "No API keys": "Нет API-ключей",
  "No API keys yet": "API-ключей пока нет",
  "No audit records match": "Нет подходящих записей аудита",
  "No background jobs match": "Нет подходящих фоновых задач",
  "No expiry": "Без срока действия",
  "No internal notes": "Нет внутренних заметок",
  "No ledger entries": "Нет операций",
  "No limit": "Без лимита",
  "No mail records match": "Нет подходящих почтовых записей",
  "No models match your search.": "По вашему запросу модели не найдены.",
  "No payment events match": "Нет подходящих событий платежей",
  "No payments": "Нет платежей",
  "No payments found": "Платежи не найдены",
  "No payments match": "Нет подходящих платежей",
  "No payments yet": "Платежей пока нет",
  "No requests in this range": "За этот период запросов нет",
  "No synchronized models": "Нет синхронизированных моделей",
  "No usage requests match": "Нет подходящих запросов",
  "No wallet entries": "Нет операций кошелька",
  "Oldest pending job:": "Самая старая ожидающая задача:",
  "on a supported Responses or Chat Completions request. The reverse proxy passes the provider-neutral event stream through LiteLLM.":
    "в поддерживаемом запросе Responses или Chat Completions. Обратный прокси передаёт нейтральный к провайдеру поток событий через LiteLLM.",
  "One API key.": "Один API-ключ.",
  "One USD paid adds one USD of wallet credit. Model usage is charged from that balance at the published rates.":
    "Один оплаченный доллар становится одним долларом на балансе. Стоимость запросов списывается по тарифу выбранной модели.",
  "Open": "Открыть",
  "Open account →": "Открыть аккаунт →",
  "Open checkout": "Перейти к оплате",
  "Open request explorer →": "Открыть журнал запросов →",
  "Open secure checkout": "Перейти к безопасной оплате",
  "Open the link within 30 minutes. You can safely close this page.":
    "Откройте ссылку в течение 30 минут. Эту страницу можно закрыть.",
  "OpenAI-compatible surface": "Совместимо с OpenAI API",
  "Operations": "Операции",
  "Operator overview": "Обзор оператора",
  "Operator request detail": "Сведения о запросе",
  "Outcome": "Результат",
  "Output / 1M": "Ответ / 1 млн токенов",
  "Output USD / 1M": "Вывод, USD / 1 млн",
  "Output tokens": "Выходные токены",
  "Page not found": "Страница не найдена",
  "Paid": "Оплачено",
  "Password": "Пароль",
  "Pay": "Оплатите",
  "Pay for what you use.": "Платите только за использование.",
  "Payload hash": "Хеш данных",
  "Payment": "Платёж",
  "Payment detail": "Сведения о платеже",
  "Payment details": "Детали платежа",
  "Payment ID": "ID платежа",
  "Payment ID, invoice ID, email, or account UUID": "ID платежа, ID счёта, email или UUID аккаунта",
  "Payment owner.": "Владелец платежа.",
  "Payment status": "Статус платежа",
  "pending payments, and": "ожидающих платежей и",
  "Permanently revoke": "Безвозвратно отозвать",
  "Permanently revoke API keys": "Безвозвратно отозвать API-ключи",
  "Permission denied": "Доступ запрещён",
  "Pick the right model for each request.": "Выберите модель под свою задачу.",
  "Platform": "Платформа",
  "Platform requests": "Запросы платформы",
  "Platform statistics": "Статистика платформы",
  "Platform, revenue, usage, margin, reliability, and operations in one safe view.":
    "Платформа, выручка, использование, маржа, надёжность и операции на одном безопасном экране.",
  "POST /v1/chat/completions": "POST /v1/chat/completions",
  "POST /v1/responses": "POST /v1/responses",
  "Prefix": "Префикс",
  "Prepaid AI API access": "Единый API для ИИ-моделей",
  "Prepaid credits, per-request costs, token categories, and limits are visible in one place.":
    "Баланс, стоимость запросов, токены и лимиты — в одном личном кабинете.",
  "Prepaid USD balance": "Предоплаченный баланс в USD",
  "Previous seven days": "Последние 7 дней",
  "Prices include the customer-facing service margin and are charged against prepaid credit.":
    "В тарифах уже учтена комиссия сервиса. Оплата списывается с баланса в USD.",
  "Processed": "Обработано",
  "Processing result": "Результат обработки",
  "Production backend": "Рабочий backend",
  "Profile": "Профиль",
  "Profile, timezone, status, and controlled account deletion.": "Профиль, часовой пояс, статус и управляемое удаление аккаунта.",
  "PROMOTION": "Промоакция",
  "Promotion to an operator role requires TOTP enrollment. Demotion revokes elevated sessions immediately.":
    "Для назначения роли оператора требуется TOTP. При понижении роли расширенные сессии сразу отзываются.",
  "Prompt and output content are not retained and therefore cannot appear here.":
    "Содержимое промптов и ответов не сохраняется, поэтому не может отображаться здесь.",
  "Protect website sign-in with TOTP.": "Защитите вход на сайт с помощью TOTP.",
  "Provider": "Провайдер",
  "Provider events": "События провайдера",
  "Provider ID": "ID провайдера",
  "Provider invoices, customer identity, settlement, and budget synchronization.":
    "Счета провайдера, данные клиента, расчёты и синхронизация бюджета.",
  "Provider reference": "Ссылка провайдера",
  "Provider-neutral payment state.": "Состояние платежа без привязки к провайдеру.",
  "Public model": "Публичная модель",
  "Public presentation and pricing metadata mirrored against LiteLLM's model catalog.":
    "Публичные названия и цены, синхронизированные с каталогом моделей LiteLLM.",
  "Queue another delivery attempt for": "Поставить в очередь повторную отправку",
  "Queue discovery from LiteLLM. This never exposes provider credentials.":
    "Запустить поиск моделей в LiteLLM. Данные доступа провайдера при этом не раскрываются.",
  "Queue jobs": "Поставить задачи в очередь",
  "Queue provider-state, wallet, and budget reconciliation. This remains idempotent.":
    "Поставить в очередь сверку состояния провайдера, кошелька и бюджета. Операция идемпотентна.",
  "Queue reconciliation": "Поставить сверку в очередь",
  "Queue retry": "Поставить повтор в очередь",
  "Queue synchronization": "Поставить синхронизацию в очередь",
  "Quickstart": "Быстрый старт",
  "Ranked by": "Сортировка по",
  "Read the API docs": "Как подключиться",
  "Reason": "Причина",
  "Reason (optional)": "Причина (необязательно)",
  "Reasoning": "Рассуждение",
  "Reasoning / 1M": "Рассуждения / 1 млн токенов",
  "Reasoning USD / 1M": "Рассуждение, USD / 1 млн",
  "Received": "Получено",
  "Recent payments": "Последние платежи",
  "Recipient": "Получатель",
  "Reconcile": "Сверить",
  "Reconcile account state": "Сверить состояние аккаунта",
  "Reconcile payment": "Сверить платёж",
  "Reconciliation": "Сверка",
  "Record ID": "ID записи",
  "Recovery codes are accepted.": "Можно использовать коды восстановления.",
  "Recovery codes are displayed once. Store them securely.": "Коды восстановления показываются один раз. Надёжно сохраните их.",
  "Refresh": "Обновить",
  "Refresh now": "Обновить сейчас",
  "Registration is paused": "Регистрация приостановлена",
  "Request account deletion": "Запросить удаление аккаунта",
  "Request activity": "Активность запросов",
  "Request date": "Дата запроса",
  "Request deletion": "Запросить удаление",
  "Request ID": "ID запроса",
  "Request metadata": "Метаданные запроса",
  "Request metadata, token categories, cost, latency, and safe errors—never prompt or output content.":
    "Метаданные запросов, категории токенов, стоимость, задержка и безопасные ошибки — без содержимого промптов и ответов.",
  "Request volume in": "Объём запросов, часовой пояс",
  "request.sh": "request.sh",
  "Requested": "Запрошено",
  "Requested public model.": "Запрошенная публичная модель.",
  "Requests": "Запросы",
  "Requests and token volume.": "Количество запросов и токенов.",
  "Resend if needed": "Отправить повторно",
  "Resend verification link": "Отправить ссылку подтверждения повторно",
  "Reset password": "Сбросить пароль",
  "Reset your password": "Сброс пароля",
  "Responses": "Responses",
  "Responses API": "Responses API",
  "Result": "Результат",
  "Retry": "Повторить",
  "Retry failed job": "Повторить задачу с ошибкой",
  "Retry job": "Повторить задачу",
  "Retry mail delivery": "Повторить отправку письма",
  "Return home": "Вернуться на главную",
  "Return one-time link": "Показать одноразовую ссылку",
  "Return to dashboard": "Вернуться в кабинет",
  "Returns the models available to the account and key. Use the model identifier in requests.":
    "Возвращает модели, доступные аккаунту и ключу. Используйте идентификатор модели в запросах.",
  "Revenue and cost": "Выручка и расходы",
  "Review browsers signed in to the management website. API keys are separate.":
    "Просматривайте браузеры, вошедшие на сайт управления. API-ключи учитываются отдельно.",
  "Revoke": "Отозвать",
  "Revoke a key immediately from the API-key screen if it is exposed. Website-session revocation does not revoke inference keys.":
    "Если ключ раскрыт, немедленно отзовите его на странице API-ключей. Отзыв веб-сессии не отзывает ключи инференса.",
  "Revoke API key": "Отозвать API-ключ",
  "Revoke API keys": "Отозвать API-ключи",
  "Revoke customer API key": "Отозвать API-ключ клиента",
  "Revoke key": "Отозвать ключ",
  "Revoke session": "Завершить сессию",
  "Revoke sessions": "Завершить сессии",
  "Revoke website session": "Завершить веб-сессию",
  "Revoke website sessions": "Завершить веб-сессии",
  "Revoke website sessions immediately": "Немедленно завершить веб-сессии",
  "Revoking website sessions does not revoke virtual API keys.": "Завершение веб-сессий не отзывает виртуальные API-ключи.",
  "Role": "Роль",
  "Role-gated changes require a reason and are audited.": "Изменения с проверкой роли требуют причины и записываются в аудит.",
  "Rotate": "Заменить",
  "Rotate and reveal replacement": "Заменить и показать новый ключ",
  "Rotate API key": "Заменить API-ключ",
  "Rotation creates a replacement with identical constraints, shows its secret once, and revokes":
    "При замене создаётся ключ с теми же ограничениями, его секрет показывается один раз, а прежний ключ отзывается:",
  "Routing, deployments, and provider credentials remain owned by LiteLLM and cannot be edited here.":
    "Маршрутизация, развёртывания и данные доступа провайдера остаются в LiteLLM и здесь не изменяются.",
  "RPM": "RPM",
  "RPM / TPM": "RPM / TPM",
  "RPM limit": "Лимит RPM",
  "USD amount": "Сумма в USD",
  "Run catalog synchronization to discover LiteLLM models.": "Запустите синхронизацию каталога, чтобы найти модели LiteLLM.",
  "Running credits": "Баланс после операции",
  "Safe account metadata.": "Безопасные метаданные аккаунта.",
  "Safe dependency checks, job pressure, and usage ingestion freshness. Refreshes every 15 seconds.":
    "Безопасная проверка зависимостей, нагрузки задач и актуальности загрузки данных. Обновляется каждые 15 секунд.",
  "Safe deployment label.": "Безопасное имя развёртывания.",
  "Safe error code": "Безопасный код ошибки",
  "Safe payload": "Безопасные данные",
  "Safe prefixes and constraints only.": "Только безопасные префиксы и ограничения.",
  "Save": "Сохранить",
  "Save changes": "Сохранить изменения",
  "Save model": "Сохранить модель",
  "Save policy": "Сохранить правила",
  "Scope every key by model, expiration, RPM, TPM, and concurrent requests.":
    "Для каждого ключа можно выбрать модели, срок действия и лимиты запросов.",
  "Search": "Поиск",
  "Search accounts, keys, or payments": "Поиск аккаунтов, ключей или платежей",
  "Search by email, UUID, display name, safe key prefix, or exact external payment ID.":
    "Ищите по email, UUID, отображаемому имени, безопасному префиксу ключа или точному внешнему ID платежа.",
  "Search models": "Найти модель",
  "Secure your operator account": "Защитите аккаунт оператора",
  "See pricing": "Посмотреть тарифы",
  "Select specific sessions, or none to revoke all.": "Выберите отдельные сессии либо ни одной, чтобы завершить все.",
  "Separate customer billing from upstream cost.": "Раздельный учёт оплаты клиентов и расходов провайдера.",
  "Set": "Установите",
  "Settle and create credit": "Подтвердить и зачислить средства",
  "Settled": "Зачислено",
  "Settled payments and adjustments appear here.": "Здесь появятся подтверждённые платежи и корректировки.",
  "Settled USD amount": "Подтверждённая сумма в USD",
  "Share": "Доля",
  "Sign in to manage your wallet, keys, and usage.": "Управляйте балансом, API-ключами и расходами.",
  "Sign out everywhere": "Выйти на всех устройствах",
  "Signature": "Подпись",
  "Signature and processing metadata without raw payloads.": "Подпись и метаданные обработки без исходных данных.",
  "Simple prepaid credit": "Простой предоплаченный баланс",
  "Six-digit code": "Шестизначный код",
  "Sort by": "Сортировать по",
  "Sort order": "Порядок сортировки",
  "Source IP": "Исходный IP",
  "Spend": "Расходы",
  "Spend synchronization is": "Синхронизация расходов:",
  "Start with a prepaid wallet and scoped virtual API keys.": "Начните с предоплаченного кошелька и виртуальных API-ключей с ограничениями.",
  "Start with full visibility": "Простой старт",
  "Started": "Начато",
  "Status": "Статус",
  "Streaming": "Потоковая передача",
  "SUCCEEDED": "Выполнено",
  "SUPER_ADMIN": "Главный администратор",
  "SUPPORT": "Поддержка",
  "SUPPORT_COMPENSATION": "Компенсация поддержки",
  "Suspend, lock, or reactivate": "Приостановить, заблокировать или активировать",
  "suspended accounts.": "приостановленных аккаунтов.",
  "Sync": "Синхронизация",
  "Synchronize catalog": "Синхронизировать каталог",
  "Synchronize model catalog": "Синхронизировать каталог моделей",
  "System health": "Состояние системы",
  "Tags (comma separated)": "Теги (через запятую)",
  "Target": "Объект",
  "Target ID": "ID объекта",
  "Target type": "Тип объекта",
  "Targets": "Цели",
  "Template": "Шаблон",
  "The page may have moved or you may not have access.": "Возможно, страница перемещена или у вас нет к ней доступа.",
  "The response follows the configured OpenAI-compatible LiteLLM surface. CodexNow does not define a separate inference schema.":
    "Ответ соответствует настроенному совместимому с OpenAI интерфейсу LiteLLM. CodexNow не задаёт отдельную схему инференса.",
  "These recovery codes are shown once. Store them offline.": "Коды восстановления показываются один раз. Храните их офлайн.",
  "This browser will lose website access on its next request. Inference API keys remain active.":
    "Этот браузер потеряет доступ к сайту при следующем запросе. API-ключи инференса останутся активными.",
  "This inserts a payment event, marks the payment paid, and creates immutable wallet credit.":
    "Это добавит событие платежа, отметит платёж оплаченным и создаст неизменяемое зачисление в кошелёк.",
  "This is your current session; you will be signed out.": "Это ваша текущая сессия; вы выйдете из аккаунта.",
  "This one-time reset link is shown once. Deliver it securely.": "Одноразовая ссылка сброса показывается один раз. Передайте её безопасно.",
  "This reduces protection on your account.": "Это снижает уровень защиты аккаунта.",
  "This reset link is missing its token.": "В ссылке сброса отсутствует токен.",
  "This view refreshes every eight seconds. Only a verified provider event or reconciliation settles credit.":
    "Страница обновляется каждые восемь секунд. Средства зачисляются только после проверенного события провайдера или сверки.",
  "Time": "Время",
  "Timezone": "Часовой пояс",
  "to": "до",
  "To": "По",
  "Tokens": "Токены",
  "Top accounts": "Лучшие аккаунты",
  "Top up": "Пополнить",
  "Top up any amount within the supported range, then spend the balance across available models.":
    "Пополните баланс на удобную сумму и используйте его для любой доступной модели.",
  "Top up wallet": "Пополнить кошелёк",
  "Top-up amount in USD": "Сумма пополнения в USD",
  "Top-ups": "Пополнения",
  "Total": "Всего",
  "TOTP or recovery code": "TOTP или код восстановления",
  "TPM": "TPM",
  "TPM limit": "Лимит TPM",
  "Trace": "Трассировка",
  "Trace ID": "ID трассировки",
  "Track payment status": "Отслеживать статус платежа",
  "Transactional delivery state and safe provider errors; tokens and template data are never exposed.":
    "Состояние транзакционной отправки и безопасные ошибки провайдера; токены и данные шаблонов не раскрываются.",
  "Two-factor authentication": "Двухфакторная аутентификация",
  "Type": "Тип",
  "Unattributed usage": "Использование без привязки",
  "Unverified": "Не подтверждена",
  "Update clients promptly. Revocation can be queued if LiteLLM is temporarily unavailable.":
    "Оперативно обновите клиенты. Если LiteLLM временно недоступен, отзыв может быть поставлен в очередь.",
  "Updated": "Обновлено",
  "Upstream": "Провайдер",
  "Usage request explorer": "Журнал запросов",
  "Usage by API key": "Использование по API-ключам",
  "Usage retained after a key could not be matched.": "Использование, для которого не удалось определить ключ.",
  "Use an IANA timezone.": "Используйте часовой пояс IANA.",
  "Use an OpenAI-compatible client against": "Используйте совместимый с OpenAI клиент с адресом",
  "Use another account": "Использовать другой аккаунт",
  "Use the client you already know.": "Подключайте привычные SDK.",
  "Used across your dashboard and receipts.": "Используется в кабинете и квитанциях.",
  "User": "Пользователь",
  "User ID": "ID пользователя",
  "Valid": "Действительна",
  "Verification activates your CodexNow account.": "Подтверждение активирует аккаунт CodexNow.",
  "Verified": "Подтверждена",
  "Verify your email": "Подтвердите почту",
  "View all": "Показать все",
  "Virtual API keys": "Виртуальные API-ключи",
  "Visible and available to customers": "Видна и доступна клиентам",
  "Visible only to operators and audited.": "Видны только операторам и записываются в аудит.",
  "Wallet entry": "Операция кошелька",
  "Wallet history": "История кошелька",
  "Wallet ledger": "История операций",
  "Wallet top-ups are currently unavailable.": "Пополнение кошелька сейчас недоступно.",
  "We’ll send a single-use link if the account is eligible.": "Если аккаунт подходит, мы отправим одноразовую ссылку.",
  "Webhook verification and processing metadata without raw provider bodies.":
    "Метаданные проверки и обработки вебхуков без исходных данных провайдера.",
  "Website sessions": "Веб-сессии",
  "Website sessions only": "Только веб-сессии",
  "Welcome back": "С возвращением",
  "with": "с помощью",
  "Your account enters deletion pending. API keys are revoked asynchronously, other sessions are revoked, and anonymization follows the configured retention policy.":
    "Аккаунт перейдёт в состояние ожидания удаления. API-ключи и другие сессии будут отозваны, а анонимизация выполнится согласно правилам хранения.",
  "Your account, spend, and API activity at a glance.": "Баланс, расходы и запросы на одном экране.",
  "Your email is verified. You can now sign in.": "Почта подтверждена. Теперь можно войти.",
  "Your latest top-ups": "Последние пополнения",
  "Your password has been changed.": "Пароль изменён.",
  "Your session expired. Sign in again to continue.": "Сессия истекла. Войдите снова, чтобы продолжить.",
  "Your signed-in role or MFA state does not allow this operator surface.":
    "Текущая роль или состояние MFA не позволяют открыть этот раздел оператора.",
  "Sending…": "Отправляем…",
  "Send reset link": "Отправить ссылку сброса",
  "That authentication code is not valid.": "Неверный код аутентификации.",
  "Signing in…": "Выполняется вход…",
  "Verifying…": "Проверяем…",
  "Verify and sign in": "Подтвердить и войти",
  "Preparing…": "Подготавливаем…",
  "Begin setup": "Начать настройку",
  "Confirming…": "Подтверждаем…",
  "Creating account…": "Создаём аккаунт…",
  "Create account": "Создать аккаунт",
  "We sent a verification link to {email}.": "Мы отправили ссылку подтверждения на {email}.",
  "Passwords do not match.": "Пароли не совпадают.",
  "Changing password…": "Меняем пароль…",
  "Change password": "Изменить пароль",
  "validation.INVALID_EMAIL": "Введите корректный адрес электронной почты.",
  "validation.PASSWORD_LENGTH": "Пароль должен содержать от 12 до 128 символов.",
  "validation.INVALID_LENGTH": "Недопустимая длина значения.",
  "validation.INVALID_TIMEZONE": "Укажите корректный часовой пояс IANA.",
  "validation.REQUIRED": "Обязательное поле.",
  "validation.INVALID_VALUE": "Недопустимое значение.",
  "Prepaid AI API": "Предоплаченный API ИИ",
  "API documentation": "Документация API",
  "Register": "Регистрация",
  "Verify email": "Подтверждение почты",
  "Forgot password": "Восстановление пароля",
  "Enroll MFA": "Настройка MFA",
  "Not found": "Не найдено",
  "Good morning, {name}": "Доброе утро, {name}",
  "Good day, {name}": "Добрый день, {name}",
  "Available balance": "Доступный баланс",
  "Balance is running low": "Баланс заканчивается",
  "Updated {date}": "Обновлено {date}",
  "7-day spend": "Расходы за 7 дней",
  "{count} request | {count} requests": "{count} запрос | {count} запроса | {count} запросов",
  "Input + cached + reasoning + output": "Ввод + кэш + рассуждение + вывод",
  "Active keys": "Активные ключи",
  "{count} total key | {count} total keys": "Всего {count} ключ | Всего {count} ключа | Всего {count} ключей",
  "Payment cancelled.": "Платёж отменён.",
  "Not assigned": "Не назначено",
  "New passwords do not match.": "Новые пароли не совпадают.",
  "Two-factor authentication enabled.": "Двухфакторная аутентификация включена.",
  "Two-factor authentication disabled.": "Двухфакторная аутентификация отключена.",
  "Updating…": "Обновляем…",
  "Optional for customer accounts; strongly recommended.": "Для клиентских аккаунтов необязательна, но настоятельно рекомендуется.",
  "Required for administrative roles.": "Обязательна для административных ролей.",
  "Session revoked.": "Сессия завершена.",
  "Amount must be between {minimum} and {maximum}.": "Сумма должна быть от {minimum} до {maximum}.",
  "Settled credits": "Зачисленные средства",
  "Billable spend": "Оплачиваемые расходы",
  "Pending credits": "Ожидающие средства",
  "Creating invoice…": "Создаём счёт…",
  "Create invoice": "Создать счёт",
  "status.ENABLED": "Включена",
  "status.DISABLED": "Отключена",
  "enum.RESPONSES": "Responses",
  "enum.CHAT_COMPLETIONS": "Chat Completions",
  "enum.STREAMING": "Потоковая передача",
  "enum.TOOLS": "Инструменты",
  "enum.VISION": "Изображения",
  "enum.REASONING": "Рассуждение",
  "{count} failed": "Ошибок: {count}",
  "Billed cost": "Начисленная стоимость",
  "Total tokens": "Всего токенов",
  "P95 latency": "Задержка P95",
  "Account settings saved.": "Настройки аккаунта сохранены.",
  "Enable MFA": "Включить MFA",
  "Create key": "Создать ключ",
  "API key settings updated.": "Настройки API-ключа обновлены.",
  "Save “{alias}”": "Сохраните «{alias}»",
  "Save rotated “{alias}”": "Сохраните замену «{alias}»",
  "Replacement created; previous-key revocation is pending.": "Новый ключ создан; прежний ожидает отзыва.",
  "API key revoked.": "API-ключ отозван.",
  "All account models": "Все модели аккаунта",
  "Edit API key": "Изменить API-ключ",
  "Saving…": "Сохраняем…",
  "Public model metadata updated.": "Публичные данные модели обновлены.",
  "Model synchronization queued.": "Синхронизация моделей поставлена в очередь.",
  "Mail retry queued.": "Повторная отправка письма поставлена в очередь.",
  "Payment reconciliation queued.": "Сверка платежа поставлена в очередь.",
  "Payment manually settled and credit created.": "Платёж подтверждён вручную, средства зачислены.",
  "Not created": "Не создана",
  "Redacted": "Скрыто",
  "enum.CREATED_AT": "Дата создания",
  "enum.EMAIL": "Email",
  "enum.DISPLAY_NAME": "Отображаемое имя",
  "enum.AVAILABLE_BALANCE": "Доступный баланс",
  "enum.BILLABLE_SPEND": "Оплачиваемые расходы",
  "enum.LAST_LOGIN_AT": "Последний вход",
  "enum.LAST_REQUEST_AT": "Последний запрос",
  "status.INACTIVE": "Неактивна",
  "status.SENDING": "Отправляется",
  "Job retry queued.": "Повтор задачи поставлен в очередь.",
  "No payload exposed": "Данные не раскрыты",
  "Registered users": "Зарегистрированные пользователи",
  "{count} new in range": "Новых за период: {count}",
  "Active users": "Активные пользователи",
  "{count} verified": "Подтверждено: {count}",
  "Paid top-ups": "Оплаченные пополнения",
  "Margin unavailable": "Маржа недоступна",
  "{percent}% margin": "Маржа {percent}%",
  "Consumed credit": "Использованные средства",
  "Upstream {amount}": "Расходы провайдера: {amount}",
  "{count} failed job | {count} failed jobs": "{count} задача с ошибкой | {count} задачи с ошибкой | {count} задач с ошибкой",
  "{count} pending payment | {count} pending payments": "{count} ожидающий платёж | {count} ожидающих платежа | {count} ожидающих платежей",
  "Redacted or unavailable": "Скрыто или недоступно",
  "Pending jobs": "Ожидающие задачи",
  "Failed jobs": "Задачи с ошибкой",
  "Usage last ingested": "Последняя загрузка использования",
  "Usage reconciled": "Последняя сверка использования",
  "Customer billed": "Начислено клиентам",
  "Upstream cost": "Расходы провайдера",
  "enum.REQUESTS": "Запросы",
  "enum.TOKENS": "Токены",
  "enum.BILLED_COST": "Начисленная стоимость",
  "enum.BASE_COST": "Базовая стоимость",
  "enum.ERRORS": "Ошибки",
  "status.NOT_REQUIRED": "Не требуется",
  "Reconciliation jobs queued.": "Задачи сверки поставлены в очередь.",
  "Account action completed.": "Действие с аккаунтом выполнено.",
  "Customer key revoked.": "Ключ клиента отозван.",
  "Website sessions revoked.": "Веб-сессии завершены.",
  "Notes": "Заметки",
  "Lifetime billed": "Начислено за всё время",
  "Enabled": "Включена",
  "Not enabled": "Не включена",
  "all": "все",
  "enum.CREDIT": "Зачисление",
  "enum.DEBIT": "Списание",
  "enum.LITELLM_USER": "Пользователь LiteLLM",
  "enum.BUDGET": "Бюджет",
  "enum.API_KEYS": "API-ключи",
  "enum.USAGE": "Использование",
  "status.PAYMENT_CREDIT": "Платёжное зачисление",
  "status.ADMIN_CREDIT": "Зачисление администратором",
  "status.ADMIN_DEBIT": "Списание администратором",
  "status.REFUND_DEBIT": "Списание возврата",
  "status.CHARGEBACK_DEBIT": "Списание возвратного платежа",
  "status.PROMOTIONAL_CREDIT": "Промозачисление",
  "status.CORRECTION_CREDIT": "Корректирующее зачисление",
  "status.CORRECTION_DEBIT": "Корректирующее списание",
  "error.NETWORK_ERROR": "Не удалось подключиться к API управления.",
  "error.HTTP_ERROR": "Сервер вернул ошибку запроса.",
  "error.VALIDATION_FAILED": "Проверьте правильность заполнения полей.",
  "error.RESOURCE_NOT_FOUND": "Запрошенный ресурс не найден.",
  "error.FORBIDDEN": "У вас нет разрешения на это действие.",
  "error.UNAUTHENTICATED": "Необходимо войти в аккаунт.",
  "error.MALFORMED_JSON": "Сервер не смог прочитать данные запроса.",
  "error.UNSUPPORTED_MEDIA_TYPE": "Неподдерживаемый формат данных.",
  "error.INTERNAL_ERROR": "Произошла внутренняя ошибка сервера.",
  "error.MFA_ENROLLMENT_REQUIRED": "Перед продолжением необходимо настроить MFA.",
  "error.MFA_REQUIRED": "Для этого действия требуется подтверждение MFA.",
  "error.ORIGIN_NOT_ALLOWED": "Источник запроса не разрешён.",
  "error.CSRF_INVALID": "Защитный токен истёк или недействителен. Повторите действие.",
  "error.IDEMPOTENCY_KEY_REQUIRED": "Не удалось безопасно идентифицировать операцию. Повторите действие.",
  "error.IDEMPOTENCY_KEY_REUSED": "Этот идентификатор уже использован для другой операции.",
  "error.AUTH_RATE_LIMITED": "Слишком много попыток. Повторите позже.",
  "error.EMAIL_ALREADY_REGISTERED": "Аккаунт с такой электронной почтой уже существует.",
  "error.INVALID_CREDENTIALS": "Неверная электронная почта или пароль.",
  "error.INVALID_MFA_CODE": "Неверный код аутентификации.",
  "error.INVALID_OR_EXPIRED_TOKEN": "Ссылка недействительна или срок её действия истёк.",
  "error.EMAIL_NOT_VERIFIED": "Сначала подтвердите электронную почту.",
  "error.ACCOUNT_LOCKED": "Аккаунт заблокирован.",
  "error.ACCOUNT_SUSPENDED": "Аккаунт приостановлен.",
  "error.ACCOUNT_ANONYMIZED": "Аккаунт анонимизирован и больше недоступен.",
  "error.PASSWORD_POLICY_FAILED": "Пароль не соответствует требованиям безопасности.",
  "error.ACCOUNT_DELETION_REQUIRES_REVIEW": "Удаление этого аккаунта требует проверки оператором.",
  "error.PAYMENT_AMOUNT_INVALID": "Сумма пополнения выходит за допустимый диапазон.",
  "error.PAYMENT_PROVIDER_UNAVAILABLE": "Платёжный провайдер временно недоступен.",
  "error.PAYMENT_PROVIDER_REJECTED": "Платёжный провайдер отклонил создание счёта.",
  "error.PAYMENT_NOT_CANCELLABLE": "Этот платёж уже нельзя отменить.",
  "error.PAYMENT_ALREADY_SETTLED": "Платёж уже подтверждён.",
  "error.API_KEY_LIMIT_REACHED": "Достигнут лимит активных API-ключей.",
  "error.API_KEY_REVOKED": "API-ключ уже отозван.",
  "error.LITELLM_UNAVAILABLE": "LiteLLM временно недоступен.",
  "error.MODEL_NOT_ALLOWED": "Запрошенная модель недоступна для этого аккаунта.",
  "error.LIMIT_EXCEEDS_ACCOUNT": "Лимит ключа не может превышать лимит аккаунта.",
  "error.STATE_CONFLICT": "Текущее состояние ресурса не позволяет выполнить действие.",
  "error.NEGATIVE_BALANCE_NOT_ALLOWED": "Операция привела бы к недопустимому отрицательному балансу.",
  "error.JOB_NOT_RETRYABLE": "Повторить можно только задачу с ошибкой или завершённую безуспешно.",
  "Yes": "Да",
  "No": "Нет",
  "None": "Нет",
  "Any": "Любой",
  "All": "Все",
  "Current": "Текущая",
  "status.ACTIVE": "Активен",
  "status.PAID": "Оплачен",
  "status.SYNCED": "Синхронизирован",
  "status.SUCCEEDED": "Выполнен",
  "status.SENT": "Отправлено",
  "status.UP": "Доступен",
  "status.AUTHENTICATED": "Авторизован",
  "status.COMPLETED": "Завершён",
  "status.CURRENT": "Текущая",
  "status.VERIFIED": "Подтверждено",
  "status.MFA_VERIFIED": "MFA подтверждена",
  "status.STANDARD": "Обычная",
  "status.PENDING": "Ожидает",
  "status.CREATING": "Создаётся",
  "status.RUNNING": "Выполняется",
  "status.DEGRADED": "Есть проблемы",
  "status.STALE": "Устарело",
  "status.PENDING_VERIFICATION": "Ожидает подтверждения",
  "status.DELETION_PENDING": "Ожидает удаления",
  "status.FAILED": "Ошибка",
  "status.DEAD": "Не выполняется",
  "status.DOWN": "Недоступен",
  "status.LOCKED": "Заблокирован",
  "status.SUSPENDED": "Приостановлен",
  "status.ANONYMIZED": "Анонимизирован",
  "status.RATE_LIMITED": "Лимит превышен",
  "status.REFUNDED": "Возвращён",
  "status.REVOKED": "Отозван",
  "status.CANCELLED": "Отменён",
  "status.EXPIRED": "Истёк",
  "status.PENDING_REVOCATION": "Ожидает отзыва",
  "status.NEVER": "Никогда",
  "status.INVALID": "Недействительна",
  "status.VALID": "Действительна",
  "status.UNKNOWN": "Неизвестно",
  "role.CUSTOMER": "Клиент",
  "role.SUPPORT": "Поддержка",
  "role.ADMIN": "Администратор",
  "role.SUPER_ADMIN": "Главный администратор",
}
